import React from 'react';
import useCurrentAmountAndCreditBalance from '../../../../../../../shared/utils/currentAmountAndCreditBalance/useCurrentAmountAndCreditBalance';
import useApplePay from '../../utils/useApplePay';

const ApplePay = () => {
  const { yourPayment } = useCurrentAmountAndCreditBalance();
  useApplePay({ yourPayment });
  return (
    <div className="payment-method-applePay" />
  );
};

export default ApplePay;
